














































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import _ from "lodash";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  days: any[] = [];

  defaultDays: any[] = [
    {
      name: "元旦",
      num: 0,
      type: 1
    },
    {
      name: "春节",
      num: 0,
      type: 1
    },
    {
      name: "清明节",
      num: 0,
      type: 1
    },
    {
      name: "劳动节",
      num: 0,
      type: 1
    },
    {
      name: "端午节",
      num: 0,
      type: 1
    },
    {
      name: "中秋节",
      num: 0,
      type: 1
    },
    {
      name: "国庆节",
      num: 0,
      type: 1
    }
  ];

  handleAdd() {
    this.days.push({
      name: "",
      num: 0,
      type: 0
    });
  }

  handleDelete(idx: number) {
    this.days.splice(idx, 1);
  }

  handleSubmit(e: any) {
    e.preventDefault();
    this.showTsConfirm({
      title: "确认信息",
      content: "确定要提交吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/saveClosuretime", {
          stadium_id: this.stadiumId,
          days: this.days
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadData1();
  }

  async loadData1() {
    const res = await this.$store.dispatch("stadium/getClosuretime", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      //   this.days = res.Data

      for (const obj of res.Data) {
        this.days.push({
          name: obj.festival,
          num: obj.days,
          type: _.find(this.defaultDays, o => o.name === obj.festival) ? 1 : 0
        });
      }
    } else {
      this.days = this.defaultDays;
    }
  }
}
